import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { style } from '../utils/style.utils';
import { componentStylesByTheme } from '../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../types/theme.types';
import { checkboxStylesSAG, checkboxStylesSHS } from './checkbox.styles';

@Directive({
  selector: 'input[sag-ui-checkbox]',
})
export class CheckboxDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      checkboxStylesSAG,
      checkboxStylesSHS
    );
    style(this.elementRef, inputStyles());
  }
}
